<template>
  <div class="APIHomepage_more">
    <div class="more-table-in">
      <div class="more-title">{{ categoryName }}</div>
      <el-button @click="isShowDrawerChange" type="primary" class="addcartBtn" v-if="multipleSelection&&multipleSelection.length">
        <img
          src="../../../assets/images/dataServices/dataapi-img/cart.svg"
          alt=""
          style="vertical-align: top;"
        />
        Add to Cart
      </el-button>
      <el-table
        ref="Usagelist"
        class="table_box table_height_30 table_font_size_14"
        :data="subcategoryList"
        style="width: 100%"
        empty-text="No Data"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          v-if="TesRecordsPageData.isShowCheckBtn_APIH_m"
        >
        </el-table-column>
        <el-table-column
          prop="apiIdStr"
          label="API ID"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="apiName"
          label="API Name"
          align="left"
          show-overflow-tooltip
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="apiCallVolume"
          label="Call Volume"
          align="center"
          show-overflow-tooltip
          width="200"
        ></el-table-column>
        <el-table-column
          prop="apiFavoriteCount"
          label="Favorite Count"
          align="center"
          show-overflow-tooltip
          width="200"
        ></el-table-column>
        <el-table-column
          prop=""
          label="Price($)"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- {{scope.row.apiPrice||'Free for test'}} -->
            Free for test
          </template>
        </el-table-column>
        <el-table-column
          prop="apiTestStatus"
          label="Test Account Support"
          align="center"
          show-overflow-tooltip
          width="200"
        >
          <template slot-scope="scope">
            <span
              :class="[
                scope.row.apiTestStatus == 1 ? 'Test-Enabled' : 'Test-Disabled',
              ]"
              >{{
                scope.row.apiTestStatus == 1 ? "Test Enabled" : "Test Disabled"
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="Operations"
          align="center"
          width="400"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>
              <div class="dataClean-operate" @click="toDetailView(scope.row)">
                View
              </div>
              <div
                class="dataClean-operate"
                @click="applyforTest(scope.row)"
                v-if="scope.row.apiTestStatus == 1"
              >
                Request Access
              </div>
              <div class="dataClean-operate disabled" v-else>
                Request Access
              </div>
              <div  class="dataClean-operate starStyle" @click.stop="isAddCartItemsClick(scope.row)">
                <img
              src="../../../assets/images/dataServices/dataapi-img/star-on.svg"
              alt=""
              v-if="scope.row.cart==1"
            />
            <img
              src="../../../assets/images/dataServices/dataapi-img/star-off.svg"
              alt=""
              v-else
            />
            
          </div>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div>
            <img
              style="width: 50%; height: 50%"
              src="../../../assets/images/noDate.png"
              alt=""
            />
          </div>
        </template>
      </el-table>
      <div class="page_i_box dataService">
        <Page
          :totalFont="true"
          :total="page.total"
          :pageSize.sync="page.pageSize"
          :currentPage="page.pageNo"
          @onPageChange="onPageChangeList"
        ></Page>

        <div class="search_rsult_txt line_2">
          {{ page.pageNo }}-{{ page.pageSize }} of over
          <span
            class="foundOverNum"
            :style="{ color: $store.state.app.themeColor }"
            >&nbsp;{{ page.total | FilterNum }}&nbsp;</span
          >
          results for "Data API"
        </div>
      </div>
    </div>
    <!-- 申请弹框 -->
    <ApplyForTestDialogVue
      :applyDialogVisible="applyDialogVisible"
      :applyfortestForm="applyfortestForm"
      :apiApplyforTestList="apiApplyforTestList"
      @getAPPKey="getAPPKey"
      @getSecretKey="getSecretKey"
      @closeApplyforTestVisible="closeApplyforTestVisible"
      @toGenerateClick="toGenerateClick"
    ></ApplyForTestDialogVue>
  </div>
</template>

<script>
import Page from "@/components/page/index.vue";
import {
  getApiDataApiPage,
  generateAppKeyInfo,
  applyAccount,
} from "@/api/dataServicesApi";
import ApplyForTestDialogVue from "../components/applyForTestDialog.vue";
import crypto from "@/utils/crypto";
export default {
  props: ["TesRecordsPageData", "cartsTotalCount"],
  data() {
    return {
      categoryId: "", //页面跳转携带过来的一级id
      categoryName: "",
      subcategoryList: [],
      applyDialogVisible: false,
      applyRow: {}, //被点击apply的当前列数据
      applyfortestForm: {
        appKey: "",
        secretKey: "",
        createTime: "",
        days: "",
        callCount: "",
      },
      apiApplyforTestList: [],
      multipleSelection:[],
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
    };
  },
  components: {
    Page,
    ApplyForTestDialogVue,
  },
  computed: {},
  watch: {},
  created() {
    this.getApiDataApiPageList();
  },
  mounted() {},
  methods: {
    // 点击购物车按钮 传递给父组件 不显示购物弹框 //批量加入购物车
    isShowDrawerChange() {
      let addCartList = [];
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((item) => {
          let obj = {
            categoryApiId: item.apiDataCategoryId,
            apiId: item.id,
            // cartEnv: 1, //环境目前1测试   生产环境待定
          };
          addCartList.push(obj);
        });
      }

      this.$emit("update-drawerStatus", true, addCartList);
    },
    // 加入/取消加入购物车 //单一
    isAddCartItemsClick(item){
      let arr =[
        {
          categoryApiId:item.apiDataCategoryId,
          apiId:item.id,
          // cartEnv:1 //环境目前1测试   生产环境待定
        }
      ]
      // false：不显示购物车弹框, arr：传递的数据 ,item.cart：加入还是取消加入购物车的状态,2表示调二级的取消接口
       this.$emit("update-drawerStatus", false, arr,item.cart,2);
    },
    // 获取二级分类
    getApiDataApiPageList() {
      this.categoryId = this.$route.query.id;
      this.categoryName = this.$route.query.categoryName;
      let params = {
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        categoryId: this.categoryId,
        apiName: this.apiName, //暂时不用 头部导航里的搜索框的值
        // apiTestStatus:'',//暂时不用 设计图没有状态搜索的设计
        apiUrl: "",
      };
      getApiDataApiPage(params).then((res) => {
        if (res.code == 200) {
          this.subcategoryList = JSON.parse(JSON.stringify(res.data.rows));
          console.log("this.subcategoryList", this.subcategoryList);
          this.categoryName = this.categoryName
            ? this.categoryName
            : this.subcategoryList[0].apiDataCategoryName;
          this.page.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // 触发事件，把数据发给父组件
      let apiIds = this.multipleSelection.map((item) => item.id);
      this.$emit("update-selection", apiIds, "2");
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getApiDataApiPageList();
    },
    formatTaskStatusClass(status) {
      //   const item = this.taskStatusOptions.find((item) => item.value == status);
      //   return item.class;
    },
    toDetailView(row) {
      this.$router.push({
        name: "APIHomepage_more_detail",
        query: {
          id: row.id,
          categoryName: this.categoryName,
          successRationStr: row.successRationStr,
        },
      });
    },
    // 申请
    async applyforTest(row) {
      this.applyRow = row; //当前点列击申请的信息
      // 获取账号信息
      await generateAppKeyInfo().then((res) => {
        if (res.code == 200) {
          let generateAppKeyInfo = JSON.parse(JSON.stringify(res.data));
          // 解密密码
          generateAppKeyInfo.secretKey = crypto.decrypt(
            generateAppKeyInfo.secretKey
          );
          this.applyfortestForm = JSON.parse(
            JSON.stringify(generateAppKeyInfo)
          );
          this.getApiDataList(this.applyRow);
          this.applyDialogVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 弹框需要的数据
    getApiDataList(row) {
      let applyArr = [
        {
          APIName: row.apiDataCategoryName,
          selectedChildren: JSON.parse(JSON.stringify([row])),
          // 给每个模块添加主题色(随机的)
          themeCssName: ["yellowTheme", "purpleTheme", "blueTheme"][
            (row.apiDataCategoryId - 1) % 3
          ],
        },
      ];
      //遍历 selectedChildren 数组，为每一项添加新属性
      applyArr[0].selectedChildren.forEach((item) => {
        item.days = this.applyfortestForm.days;
        item.callCount = this.applyfortestForm.callCount;
        item.applicationDate = this.applyfortestForm.createTime;
      });
      this.apiApplyforTestList = JSON.parse(JSON.stringify(applyArr));
    },
    // copy appkey secretKey
    async getAPPKey() {
      this.copyTool(this.applyfortestForm.appKey);
    },
    getSecretKey() {
      this.copyTool(this.applyfortestForm.secretKey);
    },
    async copyTool(data) {
      try {
        await this.$copyText(data);
        this.$message({
          message: "Copied",
          type: "success",
        });
      } catch (err) {
        this.$message({
          message: "Failed to copy: " + err,
          type: "warning",
        });
      }
    },
    closeApplyforTestVisible() {
      this.applyDialogVisible = false;
      this.applyfortestForm = {
        appKey: "",
        secretKey: "",
        createTime: "",
        days: "",
        callCount: "",
      };
    },
    // 生成(单一生成当前列数据的测试账号)
    async toGenerateClick() {
      try {
        let apiIdArr = [this.applyRow.id];
        let params2 = {
          appKey: this.applyfortestForm.appKey,
          apiId: apiIdArr, //二级的分类id
          env: 1, //1是测试2是生产
        };
        let res2 = await applyAccount(params2);
        if (res2.code == 200) {
          if (res2.data.failApisNoRepeat && res2.data.failApisNoRepeat.length) {
            // 有重复的账号被申请
            this.$message.warning({
              dangerouslyUseHTMLString: true,
              message:
                "Some APIs have already been applied. Only unapplied APIs will be processed in batch.<br><br>This API has already been applied. Please do not repeat the operation.",
            });
          } else {
            this.$message.success(res2.msg);
            // 跳转到账号管理页面
            this.$router.push({ name: "AccountManagement" });
          }
        } else {
          this.$message.error(res2.msg);
        }
        this.closeApplyforTestVisible();
      } catch (error) {
        console.log("error", error);
      }
    },
  },
};
</script>

<style scoped>
.APIHomepage_more {
  position: relative;
}
.addcartBtn {
  margin-left: 16px;
  position: absolute;
  top: 10px;
  right: 0px;
  font-size:16px;
}
.APIHomepage_more {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 50px;
}
.more-title {
  color: #1a2332;
  font-size: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}
/* 表格样式 */
.APIHomepage_more .more-table-in {
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 21px 16px;
}
.APIHomepage_more .more-table-in /deep/ .el-table__empty-text {
  padding: 85px 0;
}
.APIHomepage_more .more-table-in /deep/ th.el-table__cell {
  background: #f3f3f3;
}
.APIHomepage_more .more-table-in /deep/ td.el-table__cell {
  height: auto;
  padding: 18px 0;
}
.APIHomepage_more .more-table-in /deep/ th.el-table__cell {
  padding: 13px 0;
}
.APIHomepage_more .more-table-in /deep/ .cell {
  font-size: 16px !important;
}
.APIHomepage_more .more-table-in /deep/ .el-table__expand-icon {
  display: block !important;
}
.APIHomepage_more
  .more-table-in
  /deep/
  .el-table__expand-icon
  .el-icon-arrow-right {
  left: 50%;
  top: 50%;
  margin: 0;
  right: auto;
  transform: translate(-50%, -50%) rotate(90deg);
}
.APIHomepage_more
  .more-table-in
  /deep/
  .el-table__expand-icon.el-table__expand-icon--expanded
  .el-icon-arrow-right {
  transform: translate(-50%, -50%) rotate(180deg);
}
.APIHomepage_more .more-table-in /deep/ .el-table__expanded-cell {
  background: #f0f0f0 !important;
  padding: 14px !important;
}
.APIHomepage_more .more-table-in /deep/ .el-table__expanded-cell:hover {
  background: #f0f0f0 !important;
}
.APIHomepage_more .more-table-in /deep/ .expanded td.el-table__cell {
  border-bottom: 0 !important;
}
.APIHomepage_more .more-table-in /deep/ .tree_table_box {
  padding: 0 !important;
}
.APIHomepage_more .more-table-in .dataClean-operate {
  font-size: 16px;
  color: #b98b73;
  height: 15px;
  line-height: 15px;
  padding: 0 15px;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
}
.APIHomepage_more .more-table-in .dataClean-operate.starStyle img{
    width: 20px;
    vertical-align: middle;
}
.APIHomepage_more .more-table-in .dataClean-operate:not(:last-child) {
  border-right: 1px solid #d3d3d3;
}
.APIHomepage_more .more-table-in .dataClean-operate:first-of-type {
  padding-left: 0;
}
.APIHomepage_more .more-table-in .dataClean-operate:last-of-type {
  padding-right: 0;
}
.APIHomepage_more .more-table-in .dataClean-operate.disabled {
  color: #dfcec5;
  cursor: not-allowed;
}
.Test-Enabled::before,
.Test-Disabled::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px; /* 圆点与文本之间的间距 */
  vertical-align: middle; /* 垂直居中对齐 */
}
.Test-Enabled::before {
  background-color: #02815c;
}
.Test-Disabled::before {
  background-color: #f55656;
}
.Test-Enabled {
  color: #02815c;
}
.Test-Disabled {
  color: #f55656;
}
/* 确保 span 内部内容垂直居中 */
span.Test-Enabled,
span.Test-Disabled {
  display: inline-flex;
  align-items: center;
}
/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
  /* 字体 标题改成20px */

  /* 字体 内容改成16px 包括按钮里字体*/
  .search_rsult_txt,
  .page_txt {
    font-size: 16px !important;
  }
  /* 圆角 改成10px */
  .APIHomepage_more .more-table-in {
    border-radius: 10px;
  }
  /* padding *0.75 */
  .APIHomepage_more .more-table-in {
    padding: 16px 12px;
  }
  /* margin *0.75 */
  .more-title {
    margin-bottom: 23px;
  }
  /* 表格 表头高度 44px 内容高度50px */
  .APIHomepage_more .more-table-in /deep/ thead {
    height: auto !important;
  }
  .APIHomepage_more .more-table-in /deep/ th.el-table__cell,
  .APIHomepage_more .more-table-in /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 11px 0;
  }
  .APIHomepage_more .more-table-in /deep/ td.el-table__cell {
    padding: 14px 0;
  }
}
/* 小版本：media的范围（1440px以下）; */
@media (max-width: 1440px) {
  /* 字体 标题改成18px */
  .more-title {
    font-size: 18px;
  }
  /* 字体 内容改成14px 包括按钮里字体*/
  .APIHomepage_more .more-table-in /deep/ .cell,
  .APIHomepage_more .more-table-in .dataClean-operate,
  .search_rsult_txt,
  .page_txt {
    font-size: 14px !important;
  }
  /* 圆角 改成8px */
  .APIHomepage_more .more-table-in {
    border-radius: 8px;
  }
  /* padding *0.67 */
  .APIHomepage_more .more-table-in {
    padding: 14px 10px;
  }
  /* margin *0.67 */
  .more-title {
    margin-bottom: 20px;
  }
  /* 表格 表头高度 40px 内容高度44px*/
  .APIHomepage_more .more-table-in /deep/ thead {
    height: auto !important;
  }
  .APIHomepage_more .more-table-in /deep/ th.el-table__cell,
  .APIHomepage_more .more-table-in /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 10px 0;
  }
  .APIHomepage_more .more-table-in /deep/ td.el-table__cell {
    padding: 11px 0;
  }
}
</style>
